import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles/tokens.css";
import "./styles/global.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error('No se encontró el elemento raíz "#root".');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
